import { IEventMarketDcFromWS } from '@/types/event';
import { AbstractMarket } from '@/models/abstractMarket';
import { BetSelection } from '@/constants';

export class MarketDcItem extends AbstractMarket {
    public dc1XPrice: string | null;
    public dcX2Price: string | null;
    public dc12Price: string | null;
    public dc1XBookmakerId: number | null;
    public dcX2BookmakerId: number | null;
    public dc12BookmakerId: number | null;
    public dc1XPriceList: [number, number][] | null;
    public dcX2PriceList: [number, number][] | null;
    public dc12PriceList: [number, number][] | null;
    public feedCount: number;
    public marginPerc: string | null;

    constructor(data: IEventMarketDcFromWS) {
        super();

        this.setPreviousPrice(BetSelection.Dc1X, data.price_1x_max);
        this.setPreviousPrice(BetSelection.Dc12, data.price_12_max);
        this.setPreviousPrice(BetSelection.DcX2, data.price_x2_max);

        this.dc1XPrice = data.price_1x_max;
        this.dc12Price = data.price_12_max;
        this.dcX2Price = data.price_x2_max;
        this.dc1XBookmakerId = data.price_1x_max_site_id;
        this.dc12BookmakerId = data.price_12_max_site_id;
        this.dcX2BookmakerId = data.price_x2_max_site_id;
        this.dc1XPriceList = data.price_1x_list ? JSON.parse(data.price_1x_list) : null;
        this.dc12PriceList = data.price_12_list ? JSON.parse(data.price_12_list) : null;
        this.dcX2PriceList = data.price_x2_list ? JSON.parse(data.price_x2_list) : null;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }

    public update(data: IEventMarketDcFromWS) {
        this.setPreviousPrice(BetSelection.Dc1X, this.dc1XPrice);
        this.setPreviousPrice(BetSelection.Dc12, this.dc12Price);
        this.setPreviousPrice(BetSelection.DcX2, this.dcX2Price);

        this.dc1XPrice = data.price_1x_max;
        this.dc12Price = data.price_12_max;
        this.dcX2Price = data.price_x2_max;
        this.dc1XBookmakerId = data.price_1x_max_site_id;
        this.dc12BookmakerId = data.price_12_max_site_id;
        this.dcX2BookmakerId = data.price_x2_max_site_id;
        this.dc1XPriceList = data.price_1x_list ? JSON.parse(data.price_1x_list) : null;
        this.dc12PriceList = data.price_12_list ? JSON.parse(data.price_12_list) : null;
        this.dcX2PriceList = data.price_x2_list ? JSON.parse(data.price_x2_list) : null;
        this.feedCount = data.feeds_count;
        this.marginPerc = data.margin_perc;
    }
}
